var map = {
	"./site-logo-desktop-footer.svg": 12774,
	"./site-logo-drawer-mobile.svg": 2052,
	"./site-logo-drawer.svg": 2921,
	"./site-logo-tv.svg": 88620,
	"./site-logo-wrapper-mobile-scrolled.svg": 83023,
	"./site-logo-wrapper-mobile.svg": 31374,
	"./site-logo-wrapper-scrolled.svg": 41520,
	"./site-logo-wrapper.svg": 97919
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 73469;